// authBootstrap.js
import { createMap } from './mapInstance.js';
import {
  getAccessTokenFromUrl,
  getAccessToken,
  persistAccessToken,
  decodeJwtClaims,
  getJwtUserId,
  setAccessToken,
  isTokenExpired 
} from "./securityUtil.js";

function removeAuthTokenFromUrl() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("auth")) return;

  url.searchParams.delete("auth");
  const cleanPath = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, document.title, cleanPath || "/");
}

export function startApp() {
  const tokenFromUrl = getAccessTokenFromUrl();
  const token = tokenFromUrl || getAccessToken();

  if (!token) {
    return { authorized: false, reason: "missing" };
  }

  const claims = decodeJwtClaims(token);
  if (!claims) {
    return { authorized: false, reason: "invalid" };
  }

  if (isTokenExpired(claims)) {
    return { authorized: false, reason: "expired" };
  }

  const userId = getJwtUserId(claims);
  if (!userId) {
    return { authorized: false, reason: "invalid" };
  }

  setAccessToken(token);
  persistAccessToken(token);
  if (tokenFromUrl) removeAuthTokenFromUrl();

  const jwtContext = {
    projectId: claims.projectID,
    userId,
    country: claims.country,
    language: claims.language
  };

  return {
    authorized: true,
    token,
    claims,
    jwtContext
  };
}

export function createAuthorizedMap(jwtContext) {
  return createMap(jwtContext);
}

